import React from 'react';
import './feedback.css'
import { Link } from 'react-router-dom';
import SliderFeedback from './SliderFeedback';

export const FeedBack = () => {
  return (
    <div className='container' id='feedback-container'>
      <div className="header-container">
        <div className="head-title">What They Say About Us</div>
        <div className="head-desc">Supporting all round construction projects right from vision to reality with expertise and efficiency.</div>
      </div>

      <div className="content-container">
        <div className="feedback-container">
          {/* Removed feedbackbg image */}
          <div className="feedbackitems-container">
            <SliderFeedback />
          </div>
        </div>
        <div className="ad-container">
          <div className="adimgcontainer">
            <img src="/assets/img/mainimg.png" className='adimg' alt='ad' />
          </div>
          <div className="download-container justify-content-center">
            <Link to='https://play.google.com/store/apps/details?id=com.hidile.edraak&pcampaignid=web_share'>
              <div className="downloadbtn">
                <img
                  src="/assets/img/playstore.png"
                  alt="apple store"
                  className="download-btn"
                />
              </div>
            </Link>
          </div>
          <div className="rating-container">
            <img
              src="/assets/img/google-rating.png"
              alt="rating"
              className="rating-img"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
